var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowDownGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 30
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 22.202L7 30l7-7.798-1.418-1.362-4.615 5.137L7.968 0H6.032l-.001 25.979-4.613-5.139z",
    fill: "#6CC04A",
    fillRule: "evenodd"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIzMCIgdmlld0JveD0iMCAwIDE0IDMwIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgZmlsbD0iIzZDQzA0QSI+CiAgICAgICAgICAgIDxnPgogICAgICAgICAgICAgICAgPHBhdGggZD0iTTE4OC4yMDIgNTkwTDE5NiA1OTcgMTg4LjIwMiA2MDQgMTg2Ljg0IDYwMi41ODIgMTkxLjk3NyA1OTcuOTY3IDE2NiA1OTcuOTY4IDE2NiA1OTYuMDMyIDE5MS45NzkgNTk2LjAzMSAxODYuODQgNTkxLjQxOHoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xOTQgLTY0MikgdHJhbnNsYXRlKDIwIDYwKSBtYXRyaXgoMCAxIDEgMCAtNDE2IDQxNikiLz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+Cg==";
export { SvgArrowDownGreen as ReactComponent };